module.exports = __webpack_public_path__ + "images/project_prototype-02b0d5bc2405701ca911efb953cef6f6.svg";